import React from 'react'
import { createFileRoute } from '@tanstack/react-router'
import { AnonymousSharingPage } from '../../components/AdminAnonymousSharing/AnonymousSharingPage'

export const Route = createFileRoute('/admin/anonymous-sharing')({
  component: () => <AnonymousSharingPage />,
})
